import { createTheme } from '@elephant-healthcare/mui-theme';
import { FontConfig } from '../../types';

const generateTheme = (fonts: FontConfig) => createTheme({ fonts });

export { generateTheme };
